import React from "react";
import { LichessResponse } from "../getOpeningBookMove";
import { Progress, Table } from "@mantine/core";
import { useExclusionsStorage } from "../ZustandState";
import { Chess } from "chess.js";

interface Props {
    openingData: LichessResponse;
    isPlayersTurn: boolean;
    game: Chess;
    onMove: () => void;
}

const MoveStatistics: React.FC<Props> = ({ game, onMove, openingData, isPlayersTurn }) => {
    const excludedMoves = useExclusionsStorage((state) => state.excludedMoves);
    const setExcludedMoves = useExclusionsStorage((state) => state.setExcludedMoves);

    const transformedMoves = openingData.moves
        .map((move) => {
            const total = move.white + move.black + move.draws;
            return {
                ...move,
                white: move.white || 0,
                black: move.black || 0,
                total,
                percentageWhite: Math.round(((move.white || 0) / total) * 100),
                percentageBlack: Math.round(((move.black || 0) / total) * 100),
                percentageDraws: Math.round(((move.draws || 0) / total) * 100),
                percentage: Math.round((total / (openingData.white + openingData.black + openingData.draws)) * 100),
            };
        })
        .sort((a, b) => b.total - a.total);

    const rows = transformedMoves.map((move) => (
        <Table.Tr
            key={move.san}
            className="hover:bg-[var(--mantine-color-blue-light)] hover:cursor-pointer"
            onClick={() => {
                game.move(move.san);
                onMove();
            }}
        >
            <Table.Td align="left">{move.san}</Table.Td>
            <Table.Td align="right">{move.white + move.black + move.draws}</Table.Td>
            <Table.Td align="right">{move.percentage}%</Table.Td>
            <Table.Td width={200}>
                <Progress.Root size="xl">
                    <Progress.Section value={move.percentageWhite} color="#DDD">
                        {move.percentageWhite >= 20 && (
                            <Progress.Label className="!text-black">{move.percentageWhite}%</Progress.Label>
                        )}
                    </Progress.Section>
                    <Progress.Section value={move.percentageDraws} color="#a0a0a0">
                        {move.percentageDraws >= 20 && (
                            <Progress.Label className="!text-black">{move.percentageDraws}%</Progress.Label>
                        )}
                    </Progress.Section>
                    <Progress.Section value={move.percentageBlack} color="#555">
                        {move.percentageBlack >= 20 && <Progress.Label>{move.percentageBlack}%</Progress.Label>}
                    </Progress.Section>
                </Progress.Root>
            </Table.Td>
        </Table.Tr>
    ));

    return (
        <Table highlightOnHover>
            <Table.Tbody>{rows}</Table.Tbody>
        </Table>
    );
};

export default MoveStatistics;
